/**
 * UI vocabulary for organization lifecycle is enable/disable; the backend
 * keeps `inactive` as the stored status value.
 */
import type { OrganizationStatus } from '@optum/api-client/types';

export function orgStatusLabel(status: OrganizationStatus | string): string {
  return status === 'inactive' ? 'disabled' : status;
}
